import { convertDate } from '@assess/shared/entities';

import { dateFormatDefaultWithTimeAt } from '../constants/date-formats';
import { FormatDatePipe } from '../pipes/format-date.pipe';

const formatDate = new FormatDatePipe();

export function transformDate(date: string | Date) {
  return formatDate.transform(convertDate(date), dateFormatDefaultWithTimeAt);
}
